module.exports = __webpack_public_path__ + "yz/img/快捷.bcd40c66.jpg";